import React from 'react';
import PropTypes from 'prop-types';
import { ScrollView } from 'react-native';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import NavProfileComponent from 'modules/profile/navProfile.component';
import CommunityNav from 'modules/community/communityNav.component';
import * as navigationActions from 'modules/navigation/navigation.actions';
import { SafeAreaView } from 'react-navigation';
import SideNavFooter from 'modules/navigation/sideNavFooter.component';
import { Box, View, Image, Row, Pressable } from 'modules/styled';
import { useColorMode } from 'styles/ColorMode';

const logoLink = '/relevant/new';

const SideNav = (props) => {
  const [, setColorMode, getColor] = useColorMode();
  setColorMode('light');
  return (
    <SafeAreaView style={{ backgroundColor: getColor('white') }}>
      <ScrollView stickyHeaderIndices={[0]}>
        <Box
          sx={{
            bg: 'lightGreyBg',
            variant: 'borders.navBorder',
            borderBottomWidth: 1,
            height: 8 * 8,
          }}
        >
          <Pressable
            sx={{ alignItems: 'flex-start' }}
            onClick={() => props.actions.goToTab('discover')}
            to={logoLink}
          >
            <Row sx={{ pl: 2, flex: 1, alignItems: 'center' }}>
              <Image
                sx={{
                  height: 9 * 8,
                  width: 17 * 8,
                }}
                resizeMode={'contain'}
                source={require('public/img/logo-opt.png')}
                alt={'Relevant'}
              />
            </Row>
          </Pressable>
        </Box>
        <View sx={{ flex: 1 }}>
          <NavProfileComponent {...props} />
        </View>
        <View sx={{ flex: 1 }}>
          <CommunityNav
            viewCommunityMembers={() => props.navigation.navigate('communityMembers')}
            {...props}
          />
        </View>
        <View sx={{ flex: 1, mt: 4 }}>
          <SideNavFooter {...props} />
        </View>
      </ScrollView>
    </SafeAreaView>
  );
};

SideNav.propTypes = {
  className: PropTypes.string,
  actions: PropTypes.object,
  screenSize: PropTypes.number,
  navigation: PropTypes.object,
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  screenSize: state.navigation.screenSize,
});

export default connect(mapStateToProps, (dispatch) => ({
  actions: bindActionCreators({ ...navigationActions }, dispatch),
}))(SideNav);
